
<template>
  <el-form-item :label="params.label" class="watsonDaterange">
    <el-date-picker
      class="w150"
      size="small"
      v-model="dataRange"
      type="daterange"
      :editable="false"
      :clearable="false"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-dataRange',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      dataRange: this.params.start && this.params.end ? [new Date(this.params.start), new Date(this.params.end)] : null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.cuttentTime = minDate.getTime()
          if (maxDate) {
            this.cuttentTime = ''
          }
        },
        disabledDate: (time) => {
          if (this.cuttentTime !== '') {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.cuttentTime - one
            const maxTime = this.cuttentTime + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  created() {},
  methods: {
    reset() {
      if (this.params.dValue) {
        this.dataRange = this.params.dValue
      } else {
        this.dataRange = undefined
      }
    },
    getValue() {
      if (this.dataRange && this.dataRange.length) {
        if (this.params.key !== 'time') {
          return {
            [this.params.key + 'StartTime']: dateFormat(this.dataRange[0], 'yyyy-MM-dd 00:00:00'),
            [this.params.key + 'EndTime']: dateFormat(this.dataRange[1], 'yyyy-MM-dd 23:59:59')
          }
        } else {
          return {
            startTime: dateFormat(this.dataRange[0], 'yyyy-MM-dd 00:00:00'),
            endTime: dateFormat(this.dataRange[1], 'yyyy-MM-dd 23:59:59')
          }
        }
      }
      return undefined
    }
  },
  watch: {
    dataRange(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      if (nv) {
        cp.start = dateFormat(nv[0], 'yyyy-MM-dd')
        cp.end = dateFormat(nv[1], 'yyyy-MM-dd')
      } else {
        cp.start = undefined
        cp.end = undefined
      }
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
</style>
